// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEARCH_IN_FORUM = "H\u013eadaj v diskusi\u00e1ch na kon\u00edku...";
export const SEARCH_RESULTS_FOR = "V\u00fdsledky vyh\u013ead\u00e1vania pre slovo";
export const YOU_DID_NOT_ENTER_SEARCH_TEXT = "Zatia\u013e si ni\u010d nevyh\u013eadala. Nap\u00ed\u0161 do vyh\u013ead\u00e1va\u010da, \u010do by si potrebovala v diskusi\u00e1ch n\u00e1js\u0165.";
